module.exports = __webpack_public_path__ + "img/culture_active3.665c35d8.png";